import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 16 16">
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.333 7.333v-4h1.334v4h4v1.334h-4v4H7.333v-4h-4V7.334h4z"
      ></path>
    </svg>
  )
}

export default Icon
